export const RESOURCES = [
  {name: "main", url: "/main.png"},
  {name: "title", url: "/title.png"},
  {name: "main_title", url: "/main_title.png"},
  {name: "fog", url: "/fog.jpg"},
  {name: "do_not_enter", url: "/do_not_enter.jpg"},
  {name: "room", url: "/room.jpg"},
  {name: "shadow", url: "/shadow.jpg"},
  {name: "ruins_2", url: "/ruins_2.png"},
  {name: "ruins_3", url: "/ruins_3.png"},
  {name: "identity", url: "/identity.png"},
  {name: "identify", url: "/identify.jpg"},
  {name: "police_car", url: "/police_car.jpg"},

]

export const PAGES = [
  {
    type: "starting",
    images: {background: "main", title: "title"}
  },
  {
    type: "text",
    texts: [
      "調查這起案件整整兩年，我們終於有了突破",
      "很遺憾在追查的期間，還是有很多人因他而死"
    ],
    images: {background: "do_not_enter"}
  },
  {
    type: "text",
    texts: [
      "不過我們已經找到嫌疑犯架設的網站，他就躲在「暗網」的世界裡",
      "那是個普通人們近乎一無所知，存在著許多狂人的地方",
    ],
    images: {background: "fog"}
  },
  {
    type: "text",
    texts: [
      "他像下水道裡老鼠在黑暗中狡猾逃竄，我們不知道他是誰，也掌握不到他的行蹤",
      "有時，我彷彿能聽到，他在暗處嘲笑我們警察的聲音......",
      "但今晚不一樣了",
      "我們收到情報指出，山區的某處廢墟疑似曾經是兇手的住處",
    ],
    images: {background: "room"},
  },
  {
    type: "text",
    texts: [
      "這地方雖然已經破爛不堪",
      "但我有種直覺，我們離他不遠了",
    ],
    images: {background: "ruins_2"},
  },
  {
    type: "text",
    texts: [
      "只要能找到有用的線索，我們就能揪出兇手",
      "看到破案在即的曙光，我不自覺心跳加速"
    ],
    images: {background: "ruins_3"},
  },
  {
    type: "pixi_verify",
    items: [
      {name: "塗鴉過的紙片", desc: "上面似乎能取得指紋", pos: {x: 25, y: 85}, url: "/paper.png"},
      {name: "骯髒的塑膠袋", desc: "散發出刺鼻的氣味，不知道裝過什麼", pos: {x: 70, y: 70}, url: "/plastic.png"},
      {name: "不起眼的垃圾", desc: "氣味像是零食的包裝袋，內面發出黯淡的光澤", pos: {x: 35, y: 60}, url: "/cookie.png"},
      {name: "折斷的鉛筆", desc: "看起來在書寫什麼的時候折斷了", pos: {x: 80, y: 80}, url: "/pencil.png"},
    ],
    answer: "塗鴉過的紙片",
    images: {background: "ruins_3"}
  },
  {
    type: "text",
    texts: [
      "證物鑑識中......",
    ],
    images: {background: "identify"},
  },
  {
    type: "text",
    texts: [
      ""
    ],
    images: {background: "identify", item: "identity"},
  },
  {
    type: "text",
    texts: [
      ""
    ],
    images: {background: "police_car"}
  },
  {
    type: "text",
    texts: [
      "我們抓到他了！",
      "讓人毛骨悚然的是，他被捕時眼神沒有任何恐懼",
      "還侃侃而談殺人的理念，稱自己是淨化者，果然是個瘋子",
      "他無意自白，我們決定進入他的電腦，找尋犯罪事證",
      "然而，正當我們要存取資料",
      "果然，他對所有資料都設下了保護。但沒關係，我能破解它！"
    ],
    images: {background: "shadow"},
    alpha: 0.5
  },
  {
    type: "terminal_verify",
    code:
      `LIKE MOSES, I SPREAD THE SEA <br />
      AND LEAD PEOPLE <br />
      THE WEAK, THE <span style='color: Gold'>D</span>EFENSELESS <br />
      TO ETERNAL FREEDOM <br />
      OR MORE TO HEAVEN THROUGH &#x25A9;&#x25A9;&#x25A9;&#x25A9;&#x25A9; <br />
      <br />
      // What word is &#x25A9;&#x25A9;&#x25A9;&#x25A9;&#x25A9; (˘•ω•˘)? <br />
      // <span style='color: Gold'>D</span>`,
    input: " -> D1 -> L6 -> D1 -> R3",
    images: {background: "fog"}
  },
  {
    type: "text",
    texts: [
      "成功了！",
      "簡直難以置信，在其中一個資料夾裡存放了大量的屍體照片，數量遠遠超過我們偵辦中的案子"
    ],
    images: {background: "shadow"},
    alpha: 0.5
  },
  {
    type: "text",
    texts: [
      "我憤怒地回到拘留所質問他，他卻只是將嘴巴湊到我耳邊：",
      "「遊戲才正要開始，你猜下一個是誰會死？」",
      "那天夜裡我輾轉難眠，反覆回想他的話和在他房間看見的東西",
      "——凶器、死者照片、一幅名為「天堂島」的油畫",
      "他還有同夥",
      "我決定就算不擇手段，也要讓他從嘴裡講出來！",
    ],
    images: {background: "shadow"},
    alpha: 0.5
  },
  {
    type: "text",
    texts: [
      "沒想到他隔天竟然在拘留所自盡了，嘴上還帶著微笑，留下我滿懷著不安想著：",
      "誰，是下一個被害者？",
    ],
    images: {background: "fog"}
  },
  {
    type: "ending",
    images: {background: "main", title: "title"}
  },
  {
    type: "pixi_shader",
    images: {background: "main", title: "title"}
  }
]
